<script setup lang="ts">
const emit = defineEmits<{ close: [] }>()

const props = defineProps<{
  game: ManageGame
  tournament: ManageTournament
  onConfirm: () => void
  onCancel: () => void
}>()

const onConfirm = () => {
  props.onConfirm()
  emit('close')
}

const onCancel = () => {
  props.onCancel()
  emit('close')
}
</script>

<template>
  <UiDialog :open="true">
    <UiDialogContent
      :title="$t('Reset score')"
      :description="$t('Are you sure you want to reset the score for this game? This will reset the score for both players to 0.')"
    >
      <UiAlert :title="$t('This will also remove all throws for this game.')" />
      <div class="flex flex-row gap-2 mb-2">
        {{ game.player1?.name }} ({{ game.player1?.score }})
        <UiBadge>
          VS
        </UiBadge>
        {{ game.player2?.name }} ({{ game.player2?.score }})
      </div>
      <UiButton
        variant="destructive"
        :text="$t('Reset')"
        @click="() => onConfirm()"
      />
      <UiButton
        variant="secondary"
        :text="$t('Cancel')"
        @click="() => onCancel()"
      />
    </UiDialogContent>
  </UiDialog>
</template>
